module.exports = __webpack_public_path__ + "static/img/tool-1.058216a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tool-1.png
// module id = B+NK
// module chunks = 1